import React from 'react';
import { useSelector } from 'react-redux';
import { InputNumber } from 'antd';
import classnames from 'classnames';

/**
 * For whole amounts: a trailing fraction of one or two digits after "," or "."
 * is dropped ("1500,50" is 1500, "15,5" is 15), then the digits are kept, so a
 * thousands separator in either style ("15.000", "15,000") is not read as a
 * decimal point. A figure that is permanent must not be a hundred times too big
 * (Bohdan).
 */
export const parseWholeAmount = (value) =>
  String(value ?? '')
    .trim()
    .replace(/[.,]\d{1,2}$/, '')
    .replace(/\D/g, '');

/**
 * An amount in major units, with `precision` decimals (2 unless the caller
 * says otherwise — e.g. 0 for a currency guests pay in whole units, such as
 * COP or CLP).
 */
export default function CurrencyInput({
  value,
  onChange,
  disabled,
  id,
  currency,
  className,
  placeholder,
  precision = 2,
  parser,
  max,
}) {
  const { company } = useSelector((state) => state.currentCompany);
  const { serviceProvider } = useSelector((state) => state.currentServiceProvider);

  const _currency =
    currency ?? company?.currency ?? serviceProvider?.currency ?? serviceProvider?.regional_config?.currency;

  const formatter = (value) => {
    const [whole, fraction] = value.split('.');

    if (fraction === undefined) {
      return value;
    }

    return precision === 0 ? whole : `${whole}.${fraction.slice(0, precision)}`;
  };

  return (
    <InputNumber
      value={value}
      formatter={formatter}
      parser={parser}
      onChange={onChange}
      disabled={disabled}
      id={id}
      step={10 ** -precision}
      max={max}
      prefix={<span className="border-r border-gray-300 pr-2 mr-2 text-gray-500">{_currency}</span>}
      className={classnames('w-full', className)}
      placeholder={placeholder}
    />
  );
}
